module.exports = __webpack_public_path__ + "media/images/vector/right_arrow-9064b2f1f0e106392195ca0f55e6cb45.svg";